import { useParams } from "react-router-dom";
import { ReprocessRunDetailPage } from "@/features/ai-reprocess/ReprocessRunDetailPage";
import { useAppShell } from "@/shell/app-shell-context";
import { ApiState } from "@/shared/components/ApiState";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
import { hasRoleAtLeast } from "@/shared/utils/roles";

export function ReprocessRunDetailRoute() {
  const { runId } = useParams();
  const { token, profile } = useAppShell();
  const company = useRequireCompany();

  if (!company) return null;
  if (!hasRoleAtLeast(profile, "administrator")) {
    return <ApiState kind="error">O reprocessamento por IA é de Administrador ou acima.</ApiState>;
  }
  const parsedId = Number(runId);
  // Id não-numérico nem chega na API: vira o mesmo "não encontrado" de um
  // id de outra empresa.
  const safeId = Number.isInteger(parsedId) ? parsedId : -1;
  return (
    <ReprocessRunDetailPage
      key={safeId}
      token={token}
      runId={safeId}
      backHref={`/empresas/${company.id}/reprocessamentos`}
    />
  );
}
